exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.red-packet-container[data-v-6e124acc] {\n  padding: 20px;\n  height: 100%;\n}\n\n", ""]);

// exports
